import { useState } from 'react';

import { useButtonPressedCallback } from '@zenbusiness/application-commons-clickstream';
import SharedAsset from '@zenbusiness/common-components/SharedAsset';
import { PropTypes } from 'prop-types';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';

import { generateLogoBuilderURL } from '#client/utils/urls';

import {
  MT_DATA_TRACKING
} from './utils/constants';

const LogoBuilderBeta = ({ showLBBanner, isTRTestActive, businessEntityUuid }) => {
  const [isDismissed, setIsDismissed] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const handleDismiss = () => {
    setIsDismissed(true);
  };

  const trackClick = useButtonPressedCallback({
    ...MT_DATA_TRACKING,
    elementName: 'logo_builder_mt_banner'
  });

  const handleOnLBClick = (event) => {
    trackClick(event);
    if (isTRTestActive && !isMobile) {
      const lbPath = generateLogoBuilderURL(businessEntityUuid);
      window.open(lbPath);
    }
  };

  if (isDismissed) {
    return null;
  }

  return (
    <>
      {showLBBanner && isTRTestActive && !isMobile && (
      <Box
        bgcolor="focus90.main"
        borderRadius={3}
        px={{
          xs: 2,
          md: 4
        }}
        py={{
          xs: 2,
          md: 3
        }}
        boxShadow="0px 4px 16px 2px rgba(0, 0, 0, 0.12)"
        display="flex"
        flexDirection="column"
        gap={2}
      >
        <Box display="flex" alignItems={{ xs: 'flex-start', md: 'center' }} gap={{ xs: 2, md: 3 }}>
          <SharedAsset width={64} src="/s2/vector/logo-builder.svg" alt="logo builder" />
          <Box display="flex" flexDirection="column" gap={0.5} alignItems="flex-start" flexGrow="1">
            <Typography color="focus00.light" variant="body_mediumBold">
              Hurry, get your free logo today
            </Typography>
            <Typography color="focus00.light" variant="body_small">
              We&apos;re giving away 250 logos to celebrate the beta launch of our logo builder.
            </Typography>
          </Box>
          <Button
            color="Growth"
            sx={{
              minWidth: 'fit-content',
              display: {
                xs: 'none',
                md: 'unset'
              }
            }}
            onClick={handleOnLBClick}
          >
            Create a logo
          </Button>
          <IconButton sx={{ filter: 'invert(1)' }} onClick={handleDismiss}>
            <SharedAsset
              src="/s2/icon/e-remove-outline.svg"
              width={24}
            />
          </IconButton>
        </Box>
        <Button
          color="Growth"
          sx={{
            flexGrow: '1',
            display: {
              xs: 'unset',
              md: 'none'
            }
          }}
          onClick={handleOnLBClick}
        >
          Create a logo
        </Button>
      </Box>
      )}
    </>
  );
};

LogoBuilderBeta.propTypes = {
  showLBBanner: PropTypes.bool,
  isTRTestActive: PropTypes.bool,
  businessEntityUuid: PropTypes.string
};

export default LogoBuilderBeta;
